import { render, staticRenderFns } from "./NewTrainer.vue?vue&type=template&id=3f9e13b5"
import script from "./NewTrainer.vue?vue&type=script&lang=js"
export * from "./NewTrainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports